import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender'
import { CUSTOMER_PATH, getPageCustomers } from '../../api/customerApi'
import { useApiProgress } from '../../hooks/ApiProgress'
import CustomerPicker from '../../components/customer/CustomerPicker'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import CurrencyPicker from '../../components/currency/CurrencyPicker'
import { CURRENCIES, VALIDATION_MESSAGE } from '../../utils/constants'
import Button from '../../components/Button'
import { addCheque } from '../../api/chequeApi'
import { toast } from 'react-toastify'

const ChequeAddPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const [newCheque, setNewCheque] = useState({
        owner: "",
        deadline: "",
        currency: null,
        serialNumber: "",
        bank: "",
        branch: ""
    })
    const [customerPage, setCustomerPage] = useState({
        content: []
    });
    const [errors, setErrors] = useState({})
    const [customerQuery, setCustomerQuery] = useState('')
    const [searchTimerCustomer, setSearchTimerCustomer] = useState();
    const pendingApiCallCustomer = useApiProgress('get', `${CUSTOMER_PATH}/page`, false)
    const [customer, setCustomer] = useState()
    const searchingCustomer = async (params) => {
        if (searchTimerCustomer) clearTimeout(searchTimerCustomer);
        let timer = setTimeout(() => {
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(res.data)
                })
        }, 500);
        setSearchTimerCustomer(timer);
    }
    const onClickLoadMoreCustomer = () => {
        if (!customerPage.last) {
            loadCustomers({ search: customerQuery, lastId: customerPage.content[customerPage.content.length - 1]?.id })
        }
    }
    const loadCustomers = (params) => {
        !pendingApiCallCustomer &&
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }
    useEffect(() => {
        !isFirstRender && searchingCustomer({ search: customerQuery })
    }, [customerQuery])

    useEffect(() => {
        loadCustomers({ size: 20 })
    }, [])

    useEffect(() => {
        setNewCheque(prevState => ({ ...prevState, owner: customer ? customer.name : "" }))
    }, [customer])

    useEffect(() => {
        setErrors(prevState => ({ ...prevState, owner: undefined }))
    }, [customer])

    const onSubmit = () => {
        const body = {
            ...newCheque,
            owner: customer?.name

        }
        addCheque(body)
            .then(res => {
                toast.success('Çek kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni Çek</label>
                <CustomerPicker
                    label='Müşteri'
                    pendingApiCall={pendingApiCallCustomer}
                    state={customer}
                    setState={(value) => setCustomer(value)}
                    query={customerQuery}
                    setQuery={setCustomerQuery}
                    //error={errors.customerId}
                    page={customerPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, customerId: undefined }))}
                    onClickClear={() => setCustomer()}
                    onClickLoadMore={() => onClickLoadMoreCustomer()}
                />
                <Input
                    name='owner'
                    label='Çek Sahibi'
                    type='text'
                    placeholder='Çek sahibini girin...'
                    value={newCheque.owner}
                    error={errors?.owner}
                    onChange={e => onChange(e, setNewCheque, setErrors)}
                />
                <CurrencyPicker
                    label="Kur"
                    value={newCheque.currency}
                    onChange={(currency) => {
                        setNewCheque(prevState => ({ ...prevState, currency }))
                        setErrors(prevState => ({ ...prevState, currency: undefined }))
                    }}
                    text={(newCheque.currency) || 'Kur seçin'}
                    items={CURRENCIES}
                    error={errors?.currency}
                />
                <Input
                    name='amount'
                    label='Tutar'
                    type='number'
                    value={newCheque.amount}
                    error={errors?.amount}
                    placeholder='Tutar girin...'
                    onChange={e => onChange(e, setNewCheque, setErrors)}
                />
                <Input
                    name='deadline'
                    label='Son Tarih'
                    type='date'
                    value={newCheque.deadline}
                    error={errors?.deadline}
                    onChange={e => onChange(e, setNewCheque, setErrors)}
                />
                <Input
                    name='serialNumber'
                    label='Çek Numarası'
                    type='text'
                    value={newCheque.serialNumber}
                    error={errors?.serialNumber}
                    placeholder='Çek numarası girin...'
                    onChange={e => onChange(e, setNewCheque, setErrors)}
                />
                <Input
                    name='bank'
                    label='Banka'
                    type='text'
                    value={newCheque.bank}
                    error={errors?.bank}
                    placeholder='Banka adı girin...'
                    onChange={e => onChange(e, setNewCheque, setErrors)}
                />
                <Input
                    className='mb-3'
                    name='branch'
                    label='Şube'
                    type='text'
                    value={newCheque.branch}
                    error={errors?.branch}
                    placeholder='Şube adı girin...'
                    onChange={e => onChange(e, setNewCheque, setErrors)}
                />
                <Button
                    text='Kaydet'
                    variant='green'
                    onClick={onSubmit}
                />
            </div>
        </div>
    )
}

export default ChequeAddPage